module.exports = __webpack_public_path__ + "static/img/new3.ca44e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/szrt_revision/teachingDetail/list/mockexamination/imgs/new3.png
// module id = owyq
// module chunks = 96